import { Link } from "react-router-dom";
import { ArrowRight, Building2, Cpu, Gauge, FileDown, Handshake } from "lucide-react";

const STEPS = [
  { icon: Building2, title: "Your Business & Documents" },
  { icon: Cpu, title: "Analyse my Documents" },
  { icon: Gauge, title: "Your Score" },
  { icon: FileDown, title: "Download Your Report" },
  { icon: Handshake, title: "Get Connected to Funders" },
];

export const JourneyTeaser = () => (
  <section data-testid="journey-teaser" className="border-y border-neutral-200 bg-[#F4F8F8]">
    <div className="mx-auto max-w-7xl px-6 py-10 lg:py-12">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#0A8B85]">How Clinq Works</p>
          <h2 className="mt-1.5 text-lg font-extrabold tracking-tight text-neutral-900 md:text-lg">
            From first login to funder-ready — in five steps.
          </h2>
        </div>
        <Link to="/for-business" data-testid="journey-teaser-link"
          className="group inline-flex items-center gap-2 text-sm font-bold text-[#0A8B85] transition-colors hover:text-[#066667]">
          See the full journey
          <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
        </Link>
      </div>

      <div className="relative mt-7">
        <div className="absolute left-4 top-4 hidden h-0.5 w-[calc(100%-2rem)] bg-gradient-to-r from-[#0A8B85] via-[#0A8B85]/40 to-[#ECC764] md:block" aria-hidden="true" />
        <ol className="grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-5 md:gap-4">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <li key={s.title} data-testid={`journey-teaser-step-${i + 1}`}
                className="relative flex items-center gap-3 md:block">
                <span className="relative z-10 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#04302E] text-xs font-extrabold text-white ring-4 ring-[#F4F8F8]">
                  {i + 1}
                </span>
                <span className="flex items-center gap-2 md:mt-3">
                  <Icon className="h-4 w-4 shrink-0 text-[#0A8B85]" />
                  <span className="text-sm font-bold text-neutral-800">{s.title}</span>
                </span>
              </li>
            );
          })}
        </ol>
      </div>
    </div>
  </section>
);
